import { Injectable } from '@angular/core';
import { RouterStateSnapshot, UrlTree, Router, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../services/authentication.service';
import { GuardHelperService } from 'src/app/modules/auth/guard-helper.service';

@Injectable({
  providedIn: 'root',
})
export class SustainabilityGuard {
  constructor(
    private readonly authService: AuthenticationService,
    private readonly router: Router,
    private readonly guardHelperSvc: GuardHelperService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.guardHelperSvc.canActivate(route, state, this.canAccess.bind(this));
  }

  canAccess(url: string): boolean {
    const account = this.authService.getCurrentAccount();

    if (!account.isActive) {
      void this.router.navigateByUrl(`${account.accountUID}/unauthorized`);
    }

    return account.useSustainability;
  }
}
